export default "__VITE_ASSET__8b1b59e3__"